<ng-container *ngIf="cards; else loadingCarousel">
  <ng-container *ngIf="cards.length; else noCards">
    <mom-carousel-card *ngFor="let card of cards" [card]="card" [vertical]="true" (continue)="continue.emit(card)"></mom-carousel-card>
  </ng-container>

  <ng-template #noCards>
    <mom-carousel-empty></mom-carousel-empty>
  </ng-template>
</ng-container>

<ng-template #loadingCarousel>
  <mom-carousel-card-skeleton></mom-carousel-card-skeleton>
  <mom-carousel-card-skeleton></mom-carousel-card-skeleton>
</ng-template>
